export default __webpack_public_path__ + "static/media/cakephp-negative.635868ca.svg";